import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NotifierService } from "angular-notifier";
import { ReportService } from "../repository/service/report.service";
import { ApiRequestService } from "../services/api-request/api-request.service";
import { GoogleAnalyticsService } from "../services/google-analytics.service";
import { HomeService } from "../shared/services/home.service";
import { SidePanelService } from "../shared/services/side-pannel/side-pannel.service";
import { DomSanitizer,SafeResourceUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: "root",
})
export class StudySurveyService {
  public surveyUUID: string = null;
  public matDialogRef;
  public survey_url: any = '';
  public surveyUrlasString:string = "";
  public isSurveyReattempted: boolean = false;
  public prevState:any = {};
  public universalSurveyUrl: string = '';
  public project_name: string = null;
  public study_name: string = '';
  public prevChannel: string = '';
  public isGuestUser: boolean = true;
  public isGoogleAnalyticsSubscribed: boolean = false;
  public accessRoles:any;
  public baseurl:any = "https://node-staging.crownit.in";

  constructor(
    private router: Router,
    private reportService: ReportService,
    private notifier: NotifierService,
    private apiRequest: ApiRequestService,
    private sidePanelService: SidePanelService,
    private gtagService: GoogleAnalyticsService,
    private homeService: HomeService,
    private domSanitizer:DomSanitizer
  ) {}

  setSurveyUUID() {
    let len = this.router.url.split("/").length;
    this.prevChannel =  this.router.url.split("/")[len - 1];
    this.surveyUUID =  this.router.url.split("/")[len - 2];
    this.prevChannel = decodeURIComponent(this.prevChannel);
  }

  initNewSurvey() {
    this.setSurveyUUID();
    this.apiRequest.request('GET',`/v2/surveyPreview/${this.surveyUUID}`).subscribe((response) => {
      if(response['status'] == 1) {
        this.setSurveyUrl(this.prevChannel);
        this.getBaseUrl();
        this.survey_url = this.getSurveyUrl();
        if(this.homeService.isMobileDevice()) {
          window.location.href = this.universalSurveyUrl;
          return;
        }
        this.reportService.projectDetails = response['project_details'];
        this.reportService.formatProjectDetailsObject(this.surveyUUID);
        this.initReAttemptSurvey();
      }
    });
  }

  getBaseUrl(){
    let baseUrl = window.location.origin;
    if(baseUrl === 'https://research.crownit.in'){
      this.baseurl = 'https://feedback.crownit.in';
    }
    else if(baseUrl === 'https://research-staging.crownit.in'){
      this.baseurl = 'https://node-staging.crownit.in';
    }
    else if(baseUrl === 'https://research.eagleinsights.in'){
      this.baseurl = 'https://feedback.crownit.in'
    } else{
      this.baseurl = 'https://node-staging.crownit.in';
    }
  }


  getSurveyUrl() {
    let url = `${this.baseurl}/smartsurvey/#/question/${this.surveyUUID}?prevChannel=${this.prevChannel}&survey=prev${Math.floor(Math.random() * 90000) + 10000}`;
    return url;
    // let url = `https://feedback.crownit.in/smartsurvey/#/question/${this.surveyUUID}?prevChannel=${this.prevChannel}&survey=prev${Math.floor(Math.random() * 90000) + 10000}`;
    // return url;
    // return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  initReAttemptSurvey() {
    this.project_name = this.reportService.projectDetails.project_name;
    if(this.reportService.projectDetails.studies.length) {
      this.study_name = this.reportService.projectDetails.studies[0].study_name;
    }
    let accessRoles = JSON.parse(localStorage.getItem('access'));
    if(!accessRoles) {
      this.isGuestUser = true;
      this.sidePanelService.sideDrawer.subMenu = [];
      this.sidePanelService.SetRepoMenusDetails(true);
    } else {
      this.isGuestUser = false;
      if(!this.sidePanelService.isSurveyPreviewFromResearch){
        this.sidePanelService.initSideDrawer('home');
        // this.reportService.initSideDrawerEvent.emit('repo');
      }
    }
    this.homeService.isOpen = true;

    // once universal link starts working below function call can be commented
    this.increaseUrlPrevNumber();
  }

  setSurveyUrl(webLink) {
    this.universalSurveyUrl = `http://crwn.in/p/${webLink}`;
  }

  shareSurvey(data) {
    this.apiRequest.request('POST','/v2/sharePreviewLink',data).subscribe((response) => {
      if(response['status'] == 1) {
        this.notifier.notify('success','Survey Shared Successfully');
        this.matDialogRef.close();
      } else {
        this.notifier.notify('error','Something Went Wrong');
      }
    });
  }

  unsetData() {
    if(!this.isSurveyReattempted) {
      this.surveyUUID = null;
      this.reportService.projectDetails = {};
    }
  }

  reloadCurrentPage(){
    window.location.reload();
    // let currentUrl = decodeURIComponent(this.router.url);
    // this.router.navigate([currentUrl]);
    // this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
    // });
  }

  increaseUrlPrevNumber() {

    let urlArr = this.survey_url.split('survey=prev');
    let newPrevNum = +urlArr[1] + 1;
    this.survey_url = `${urlArr[0]}survey=prev${newPrevNum}`
  }

  sendSurveyGAEvent(eventName: string,options:any) {
    options = {...options,event_category: "Survey Preview Research Panel"};

    if(this.isGuestUser) {
      options = {...options, user_type: 'Guest'}
    } else {
      options = {...options, user_type: 'Known',logged_in_user_id: this.accessRoles.id}
    }

    this.gtagService.sendGAEvent(eventName, options);
  }
}